import axios from 'axios'
import { i18n } from '../main'

const apiClient = axios.create({
  baseURL:  `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  },
  timeout: 10000 //Throw error if API call takes longer than 10 sec//
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.authorization = 'Bearer '+ token
    }
    config.headers.lang = i18n.locale.toUpperCase()
    return config
  },
  (error) => Promise.reject(error),
)

const apiFileClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: true,
  headers: {
    Accept: 'application/pdf',
    'Content-type': 'application/json'
  },
  responseType: 'blob'
})

apiFileClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.authorization = 'Bearer ' + token
    }
    return config
  },
  (error) => Promise.reject(error),
)

export default {
  fetchMarketPlaceProducts() {
    return apiClient.get('/marketplace/products')
  },
  fetchMarketPlaceProductById(body) {
    return apiClient.post(`/marketplace/fetch/product`, body)
  },
  sendInquiry(body) {
    return apiClient.post('/marketplace/send/inquiry', body)
  },
  searchProducts(searchBody) {
    return apiClient.post(`/marketplace/search/products`, searchBody)
  },
  purchaseMarketPlaceProduct(body) {
    return apiClient.post(`/marketplace/purchase/product`, body)
  },
  fetchPurchasedProductIds() {
    return apiClient.get('/marketplace/fetch/purchased/product')
  },
  fetchMarketPlaceProductsForAdmin() {
    return apiClient.get('/marketplace/admin/products')
  },
  addProductToMarketPlaceAdmin(body) {
    return apiClient.post(`/marketplace/admin/add/product`, body)
  },
  deleteProductFromMarketPlaceAdmin(body) {
    return apiClient.post(`/marketplace/admin/delete/product`, body)
  },
  fetchMarketPlaceExperiences() {
    return apiClient.get('/marketplace/list/experiences')
  },
  addExpToCatalogue(body) {
    return apiClient.post(`/marketplace/add/exp/catalogue`, body)
  },
  fetchPurchasedExpIds() {
    return apiClient.get('/marketplace/fetch/purchased/experience')
  },
  searchExperiences(body) {
    return apiClient.post(`/marketplace/search/experiences`, body)
  },
  downloadExperienceListPDF(body) {
    return apiFileClient.post(`/marketplace/experiences/pdf`, body)
  },
  downloadProductListPDF(body) {
    return apiFileClient.post(`/export/products/pdf`, body)
  },
  checkCategoryExist(body) {
    return apiClient.post(`/check/category/exist`, body)
  }
}
